import React from 'react';
import styles from './styles'


function Reports(): JSX.Element {

    return (
        <div id="reports" className="container">
            <h1>Reports</h1>
            <a href="https://drive.google.com/file/d/1YFJFxf_OePJ9rdGxjcB5f2Tf-C8gRsSN/view" style={styles.linkText}>Innovation Expert Form</a>
            <br />
            <a href="https://drive.google.com/file/d/1USGxcpJWvbJKCpk1NCP0nzfEE9c5UUCA/view" style={styles.linkText}>Specification Report</a>
            <br />
            <a href="https://drive.google.com/file/d/1fKFGfLFuHx_zcD0snXXP-a0QgCyaZpXP/view" style={styles.linkText}>Analysis Report</a>
            <br />
            <a href="https://drive.google.com/file/d/1CfY7_NcnUTSbwOT2ejyzk5b-f0D9tc9_/view" style={styles.linkText}>High Level Design Report</a>
            <br />
            <a href="https://drive.google.com/file/d/1nW3KmqDcj4XfDZYeiRP-b2gVrdBtNoIu/view" style={styles.linkText}>Low Level Design Report</a>
        </div>
    )
}

export default Reports;